import { useTranslation } from "react-i18next";

import { Grid2 } from "@mui/material";

import { Divider } from "../../../../../../components/ui/Divider/Divider";
import { DesktopTableRow } from "./TableRow/DesktopTableRow";

import { GridItem } from "./IpsTableDesktop.styled";

export const IpsTableDesktop = ({ ips, webRtcStatus, userIp }) => {
  const { t } = useTranslation();

  const tableHead = ["IP", t("global.provider"), t("global.status")];

  return (
    <Grid2 container>
      {tableHead.map(title => (
        <GridItem key={title} size={{ md: 4 }}>
          {title}
        </GridItem>
      ))}
      <Divider />
      {webRtcStatus ? (
        ips.map(({ ip }) => (
          <DesktopTableRow
            key={ip}
            ip={ip}
            provider="Public IPv4"
            status={webRtcStatus}
            statusLabel={
              webRtcStatus
                ? t("webrtcCheck.possibleLeak")
                : t("webrtcCheck.notPossibleLeak")
            }
          />
        ))
      ) : (
        <DesktopTableRow
          ip={userIp || ""}
          provider="Public IPv4"
          status={webRtcStatus}
          statusLabel={
            webRtcStatus
              ? t("webrtcCheck.possibleLeak")
              : t("webrtcCheck.notPossibleLeak")
          }
        />
      )}
    </Grid2>
  );
};
